import {Injectable} from '@angular/core';
import {GritApiService} from "./grit.api.service";
import {PointsService} from "../points.service";
import {InterferenceTestModel} from "../../models/grit/grit.interference-test-model";
import {GritFilter} from "../../models/grit/grit.filter";
import {FeatureType} from "../../models/EnumTypes";
import {GritFeature} from "../../models/grit/grit.feature";
import {MapService} from "../map.service";
import {UserSettingsService} from "../userSettings.service";
import {UiBlockService} from "../ui-block.service";
import {FilterMode, FilterTab} from "./grit.feature-filter.service";
import {ModalControlService} from "../modal-control.service";
import {InterferenceTestModelStates} from "../../models/grit/grit.enums";
import { StyleLike } from 'ol/style/Style';

@Injectable({
  providedIn: 'root'
})
export class GritInterferenceTestService {

  projectInterferenceTest: InterferenceTestModel;
  focusPublicInterferenceTest: InterferenceTestModel = null;

  public detailsTab = {
    active : false,
    selected : null as InterferenceTestModel,
    tab: 0,
  }

  public filterTab : FilterTab = new FilterTab(
    FeatureType.InterferenceTest,
    InterferenceTestModel.configuration.filters,
    (filters: GritFilter[]) => {
      this.userSettingsService.userSettings.interferenceTestSettings.filters = filters;
      this.userSettingsService.updateSettings();
      return true;
    },
    () => {
      this.focusPublicInterferenceTest = null;

      this.pointsService.clearOtherInterferenceTestFromMap();
      this.pointsService.fetchAndAddInterferenceTest();
    },
    (feature: GritFeature<InterferenceTestModel>, mode : FilterMode, result: boolean) => {
      if(mode == FilterMode.ONLY && !result) {
          this.pointsService.tabsService.removeInterferenceTestTabById(feature.entity.id);
      }

      return false;
    })

  constructor(
    private gritAPIService: GritApiService,
    private pointsService: PointsService,
    private mapService:MapService,
    private userSettingsService:UserSettingsService,
    private uiBlock: UiBlockService,
    protected modalService: ModalControlService,

  ){
    this.pointsService.interferenceTestService = this;
  }

  allowedStates(...levels: InterferenceTestModelStates[]): boolean {
    let interferenceTest = this.projectInterferenceTest;

    if (interferenceTest == null || (this.detailsTab.selected && this.detailsTab.selected.id != interferenceTest.id)) return false;

    return levels.length == 0 || levels.some(level => interferenceTest.state.startsWith(level));
  }

  toggleDetails(active: boolean, id : number = null){
    this.detailsTab.active = active;
    this.pointsService.getSelectedFeaturesOfType(FeatureType.InterferenceTest).forEach((feature : GritFeature<InterferenceTestModel>) => {
      this.pointsService.removeSelectedFeature(feature);
      feature.setStyle(feature.layer.getStyle() as StyleLike);
    })

    if (!active || id == null) return;

    let feature = this.pointsService.getInterferenceTestFeature(id);

    let interferenceTest = feature.entity

    if (interferenceTest === null || interferenceTest.id === this.projectInterferenceTest?.id){
      interferenceTest = this.projectInterferenceTest
      this.detailsTab.selected = interferenceTest;

    }else{
      this.detailsTab.selected = Object.assign(new InterferenceTestModel(), interferenceTest);
    }

    this.detailsTab.tab = 0;

    this.focus(false);
  }

  focus(zoom: boolean = true, id : number = this.detailsTab.selected.id){
    let feature = this.pointsService.getInterferenceTestFeature(id);
    if (!feature.getGeometry()) return; //No geometry defined

    feature.setStyle(feature.layer.getStyleSelected())
    this.pointsService.addSelectedFeature(feature);

    if(!zoom) return;

    let view = this.mapService.getMap("map").getView();
    let ext = feature.getGeometry().getExtent();
    view.fit(ext, {padding: [0, 0, 500, 0], maxZoom: 20});
  }

  async resetProjetInterferenceTest(interferenceTest: InterferenceTestModel = null){
    try {
      if (interferenceTest == null){
        this.uiBlock.startBlock("Getting project interference test");
        interferenceTest = await this.gritAPIService.interferenceTestGet();
        this.uiBlock.stopBlock();
      }

      this.projectInterferenceTest = interferenceTest;

      if (interferenceTest != null){
        this.pointsService.addProjectInterferenceTestToMap(interferenceTest)

        if(this.detailsTab.selected?.id == interferenceTest.id){
          this.detailsTab.selected = interferenceTest;
        }else{
          this.detailsTab.selected = null;
        }
      }
    } catch (error) {
      this.uiBlock.stopBlock();
      this.modalService.showMesssageModal("Error Loading Project", `Error:\n ${error}`);
    }

  }

  activateProject(publicProject: boolean){
    this.focusPublicInterferenceTest = null;
    this.projectInterferenceTest = null;
    this.filterTab.addedFilters = this.userSettingsService.userSettings.interferenceTestSettings.filters.map(filter => new GritFilter().fromDto(filter))

    if (!publicProject) this.resetProjetInterferenceTest();
  }
}
